import { Injectable } from "@angular/core";
import moment from "moment";
import { Subject } from "rxjs";
import { GraphicsRepository } from "../domain/graphics-repository";
import { MediaRepository } from "../domain/media-repository";
import { MediaItem } from "../domain/media";
import { GraphicsInfo } from "../domain/graphics-info";
import { ILayoutsRepository } from "../domain/layouts/layouts.repository";
import { Layout } from "../domain/layouts/layout";
import { IBlockRepository } from "../domain/blocks/i-block.repository";
import { Block } from "../domain/blocks/block";
import { LiveFeed } from "../domain/live-feed";
import { LiveFeedRepository } from "../domain/live-feed-repository";
import { IBroadcastsRepository } from "../domain/broadcasts/i-broadcasts-repository";
import { BroadcastPreset } from "../domain/broadcasts/broadcast-preset";

@Injectable()
export class SearchService {
  constructor(
    private graphicsRepository: GraphicsRepository,
    private mediaRepository: MediaRepository,
    private _layoutsRepository: ILayoutsRepository,
    private _blocksRepository: IBlockRepository,
    private _liveFeedRepository: LiveFeedRepository,
    private _broadcastsRepository: IBroadcastsRepository,
  ) {}

  searchMode = "video";
  orderByMedia = 0;
  orderByGraphics = 0;
  sortByMedia = "Name";
  sortByGraphics = "Name";
  searchQuery = "";
  statusChosen = "All";
  tags = [];
  assetTypes = [];
  languages = [];
  countries = [];
  templates: { id: number; name: string }[] = [];
  history = [];
  searchHistoryLimit = 10;

  startDateCreatedMedia: moment.Moment = null;
  endDateCreatedMedia: moment.Moment = null;

  startDateCreatedGraphics: moment.Moment = null;
  endDateCreatedGraphics: moment.Moment = null;

  startDateLicense: moment.Moment = null;
  endDateLicense: moment.Moment = null;

  searchServiceSubject = new Subject<any>();
  searchServiceMode = new Subject<any>();

  subjectNext() {
    this.searchServiceSubject.next(true);
  }

  subjectModeNext() {
    this.searchServiceMode.next(true);
  }

  addHistory(searchQuery: string) {
    if (
      this.searchHistoryLimit === -1 ||
      this.history.length < this.searchHistoryLimit
    ) {
      this.history.push(searchQuery);
    } else {
      this.history.splice(0, 1);
      this.history.push(searchQuery);
    }
  }

  search(
    offset?: number,
  ): Promise<
    | MediaItem[]
    | GraphicsInfo[]
    | Layout[]
    | Block[]
    | LiveFeed[]
    | BroadcastPreset[]
  > {
    if (this.searchMode === "video") {
      return this.mediaRepository.getMedia(
        this.searchQuery,
        offset,
        this.orderByMedia,
        this.sortByMedia,
        this.startDateCreatedMedia,
        this.endDateCreatedMedia,
        this.startDateLicense,
        this.endDateLicense,
        this.statusChosen,
        this.countries.map((x) => x.id),
        this.tags.map((x) => x.id),
        this.assetTypes.map((x) => x.id),
        this.languages.map((x) => x.code),
      );
    } else if (this.searchMode === "graphics") {
      return this.graphicsRepository.getGraphicsSearch(
        this.searchQuery,
        this.orderByGraphics,
        this.sortByGraphics,
        this.startDateCreatedGraphics,
        this.endDateCreatedGraphics,
        this.templates.map((x) => x.id),
      );
    } else if (this.searchMode === "layouts") {
      return this._layoutsRepository.getLayouts(this.searchQuery);
    } else if (this.searchMode === "blocks") {
      return this._blocksRepository.get(this.searchQuery);
    } else if (this.searchMode === "live") {
      return this._liveFeedRepository.getLiveFeeds(this.searchQuery);
    } else if (this.searchMode === "broadcasts") {
      return this._broadcastsRepository.get(this.searchQuery);
    } else {
      return Promise.resolve([]);
    }
  }

  isFiltered(): "hidden" | "visible" {
    if (
      this.searchMode === "video" &&
      this.searchQuery === "" &&
      this.sortByMedia === "Name" &&
      this.statusChosen === "All" &&
      this.tags.length === 0 &&
      this.assetTypes.length === 0 &&
      this.languages.length === 0 &&
      this.countries.length === 0 &&
      !this.startDateCreatedMedia &&
      !this.endDateCreatedMedia &&
      !this.startDateLicense &&
      !this.endDateLicense
    ) {
      return "hidden";
    } else if (
      this.searchMode === "graphics" &&
      this.searchQuery === "" &&
      this.sortByGraphics === "Name" &&
      this.templates.length === 0 &&
      !this.startDateCreatedGraphics &&
      !this.endDateCreatedGraphics
    ) {
      return "hidden";
    }
    return "visible";
  }
}
